/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const accountFeatureFlagListNameMax = 255;

export const accountFeatureFlagListCodeMax = 255;

export const AccountFeatureFlagList = zod.strictObject({
    name: zod.string().max(accountFeatureFlagListNameMax),
    code: zod.string().max(accountFeatureFlagListCodeMax),
    created_at: zod.iso.datetime({ offset: true }),
    updated_at: zod.iso.datetime({ offset: true }),
});

export type AccountFeatureFlagList = zod.input<typeof AccountFeatureFlagList>;
export type AccountFeatureFlagListOutput = zod.output<
    typeof AccountFeatureFlagList
>;
